import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { Button, Dropdown } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { Link } from 'react-router-dom';
import ChevrondownIcon from 'icons/Chevrondown.icon';
import ManageContactDrawer from '../ManageContactDrawer';
import { SideDrawerRef } from 'router/subrouters/DataRoom/components/SideDrawer/SideDrawer.component';
import { Contact } from 'models/Contact';
import { CONTACTS_ROUTE } from 'data/global';

import './Heading.styles.scss';
import './Heading.styles.responsive.scss';

type HeadingProps = {
  className?: string;
  title: string;
  onSuccess?: (contact: Contact) => void;
};

const Heading: React.FC<HeadingProps> = (props) => {
  const { className, children, title, onSuccess } = props;

  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>();
  const [manageContactDrawer, manageContactDrawerRef] =
    useCallbackRef<SideDrawerRef>();

  const classes = classNames('contacts-heading', className);

  const { t } = useTranslation();

  const renderTrigger = useMemo(
    () => (
      <Button icon={ChevrondownIcon} iconPosition="right">
        {t('addContacts')}
      </Button>
    ),
    [t],
  );

  const closeDropdown = useCallback(
    () => dropdown?.setIsOpen(false),
    [dropdown],
  );

  return (
    <div className={classes}>
      <h1>{title}</h1>

      {children}

      <ManageContactDrawer ref={manageContactDrawerRef} onSuccess={onSuccess} />

      <Dropdown
        closeWithJS
        renderAsPortal
        trigger={renderTrigger}
        ref={dropdownRef}
        contentClassName="contact-heading-dropdown-content"
      >
        <ul>
          <li>
            <Link to={`${CONTACTS_ROUTE}/add`} onClick={closeDropdown}>
              {t('bulkContactUpload')}
            </Link>
          </li>

          <li>
            <Button
              variant="link"
              onClick={() => {
                closeDropdown();
                manageContactDrawer?.setOpen(true);
              }}
            >
              {t('singleContactCreation')}
            </Button>
          </li>
        </ul>
      </Dropdown>
    </div>
  );
};

export default Heading;
